/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hotel_Logo_AltInputs */

const en_hotel_logo_alt = /** @type {(inputs: Hotel_Logo_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`airapvideo logo`)
};

/**
* | output |
* | --- |
* | "airapvideo logo" |
*
* @param {Hotel_Logo_AltInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const hotel_logo_alt = /** @type {((inputs?: Hotel_Logo_AltInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hotel_Logo_AltInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hotel_logo_alt(inputs)
});
export { hotel_logo_alt as "hotel.logo_alt" }